const CarbonCreditPublicSale = {
  "_format": "hh-sol-artifact-1",
  "contractName": "CarbonCreditPublicSale",
  "sourceName": "contracts/core/CarbonCreditPublicSale.sol",
  "abi": [
    {
      "inputs": [],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "inputs": [],
      "name": "ACTIVE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "AUTH",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "EMPTY_QUEUE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "HIGH_COMMISSION",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INSUFFICIENT_AVAILABLE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "INSUFFICIENT_BALANCE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "KYC_REQUIRED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOTHING_TO_CANCEL",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_ACTIVE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_COMMISSION",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_LISTING",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "isPartner",
          "type": "bool"
        }
      ],
      "name": "CommissionWithdrawn",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "seller",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "price",
          "type": "uint256"
        }
      ],
      "name": "Listed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "seller",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "ListingCancelled",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "Paused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "buyer",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "totalCost",
          "type": "uint256"
        }
      ],
      "name": "Purchased",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "Unpaused",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "biotoken",
      "outputs": [
        {
          "internalType": "contract IERC1155",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "buy",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "cancelListing",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "newPrice",
          "type": "uint256"
        }
      ],
      "name": "changePrice",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "end",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "factory",
      "outputs": [
        {
          "internalType": "contract IUnifiedFactory",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "year",
          "type": "uint256"
        }
      ],
      "name": "getAllListings",
      "outputs": [
        {
          "components": [
            {
              "internalType": "address",
              "name": "seller",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "price",
              "type": "uint256"
            }
          ],
          "internalType": "struct CarbonCreditPublicSale.Listing[]",
          "name": "",
          "type": "tuple[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "getBestPrice",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "price",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "available",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getListedTokenIds",
      "outputs": [
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "getListings",
      "outputs": [
        {
          "components": [
            {
              "internalType": "address",
              "name": "seller",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "price",
              "type": "uint256"
            }
          ],
          "internalType": "struct CarbonCreditPublicSale.SaleListing[]",
          "name": "",
          "type": "tuple[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getTokenIdCount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "year",
          "type": "uint256"
        }
      ],
      "name": "getTotalListedByUserYear",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "totalListed",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "user",
          "type": "address"
        }
      ],
      "name": "getUserListings",
      "outputs": [
        {
          "components": [
            {
              "internalType": "address",
              "name": "seller",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "price",
              "type": "uint256"
            }
          ],
          "internalType": "struct CarbonCreditPublicSale.Listing[]",
          "name": "",
          "type": "tuple[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        }
      ],
      "name": "getUserListingsByToken",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "year",
          "type": "uint256"
        }
      ],
      "name": "getYearlyTotalAvailable",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "totalAvailable",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "stableCoin_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "biotoken_",
          "type": "address"
        },
        {
          "internalType": "address payable",
          "name": "partnerAddress_",
          "type": "address"
        },
        {
          "internalType": "address payable",
          "name": "operatorAddress_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "projectAddress_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "factoryAddress_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "stakingContractAddress_",
          "type": "address"
        },
        {
          "internalType": "uint8",
          "name": "usdCommission_",
          "type": "uint8"
        },
        {
          "internalType": "uint8",
          "name": "partnerUsdCommission_",
          "type": "uint8"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "kycEnabled",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "kycWhitelist",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "price",
          "type": "uint256"
        }
      ],
      "name": "listForSale",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "price",
          "type": "uint256"
        }
      ],
      "name": "listForUser",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "listedTokenIds",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "listings",
      "outputs": [
        {
          "internalType": "address",
          "name": "seller",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "price",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        },
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "name": "onERC1155BatchReceived",
      "outputs": [
        {
          "internalType": "bytes4",
          "name": "",
          "type": "bytes4"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "name": "onERC1155Received",
      "outputs": [
        {
          "internalType": "bytes4",
          "name": "",
          "type": "bytes4"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "operatorAddress",
      "outputs": [
        {
          "internalType": "address payable",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "partnerAddress",
      "outputs": [
        {
          "internalType": "address payable",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "partnerUsdCommission",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "partnerUsdCommissionAmount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "pause",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "paused",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "pendingSales",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "projectAddress",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_kycWhitelist",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "_enabled",
          "type": "bool"
        }
      ],
      "name": "setKYCWhitelist",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stableCoin",
      "outputs": [
        {
          "internalType": "contract IERC20",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stage",
      "outputs": [
        {
          "internalType": "enum CarbonCreditPublicSale.SaleStage",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stakingContractAddress",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "start",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes4",
          "name": "interfaceId",
          "type": "bytes4"
        }
      ],
      "name": "supportsInterface",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "tokenIdListed",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "tokenTotalAvailable",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "usdCommission",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "usdCommissionAmount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "userTokenBalances",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "withdrawCommission",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "withdrawPartnerCommission",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
};

export default CarbonCreditPublicSale;
